<template>
  <v-dialog v-model="dialogModel" persistent scrollable>
    <v-card>
      <v-flex class="d-flex align-center">
        <v-flex class="text-xs-right">
          <v-btn outline small depressed @click="addNewCustomer">
            <v-icon left>person_add</v-icon>  NEW CUSTOMER 
          </v-btn>
          <v-btn flat @click="dialogModel = false">
            <v-icon left small>close</v-icon> Close
          </v-btn>
        </v-flex>
      </v-flex>

      <v-divider></v-divider>

      <v-flex>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs6 sm4 md3 lg2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="customerQueryParams.code"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="customerQueryParams.name"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                v-model="customerQueryParams.email"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-text-field
                name="township"
                label="TownShip"
                type="text"
                v-model="customerQueryParams.township"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-btn outline color="primary" @click="customerOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-divider></v-divider>

      <v-card-text height="500">
        <!-- Customer List Section -->
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="customerList"
              class="elevation-1"
              :loading="showCustomerListLoading"
              :total-items="customerTotalRows"
              :rows-per-page-items="customerRowsPerPageItems"
              :pagination.sync="customerPagination"
              :must-sort="true"
              height="300"
              fixed
            >
              <template slot="items" slot-scope="props">
                <td @click="apply(props.item)">
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>

    <!-- customer add dialog -->
    <customer-add-dialog
      :showDialog="customerAddDialog"
      @close="onCloseNewCustomer"
    />
  </v-dialog>
</template>

<script>
import { creditLevelService } from "../../services/credit-level-service";
import { customerService } from "../../services/customer-service";
import CustomerAddDialog from "../customer/CustomerAddDialog.vue";
export default {
  components: { CustomerAddDialog },
  props: ["dialog", "queryParams"],
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    customerQueryParams: {
      code: "",
      name: "",
      email: "",
      creditLevelId: "",
      township: "",
      regionId: "",
      isNoRegion: Boolean,
      status: "",
      saleTeamId: "",
    },
    customerRowsPerPageItems: [25, 50, 100],
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    showCustomerListLoading: false,
    customerList: [],
    customerTotalRows: 0,
    creditLevelList: [],
    customerAddDialog: false,
  }),
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("update:dialog");
      },
    },
  },
  watch: {
    dialogModel(v) {
      if (v) {
        this.customerQueryParams = Object.assign(
          this.customerQueryParams,
          this.queryParams
        );
        this.customerOnSearch();
      } else {
        this.customerQueryParams.name = "";
        this.customerQueryParams.email = "";
        this.customerQueryParams.creditLevelId = "";
        this.customerQueryParams.township = "";
      }
    },
    customerPagination: {
      handler() {
        this.customerOnSearch();
      },
      deep: true,
    },
  },
  created() {
    this.getCreditLevels();
  },
  methods: {
    customerOnSearch() {
      if (this.dialog) {
        this.customerQueryParams.page = this.customerPagination.page;
        this.customerQueryParams.size = this.customerPagination.rowsPerPage;
        this.getCustomerList();
      }
    },
    async getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";

      try {
        const res = await customerService.getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        );
        if (res.data) {
          this.customerList = res.data.customerList;
          this.customerTotalRows = res.data.totalElements;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.showCustomerListLoading = false;
      }
    },
    apply(customer) {
      this.$emit("apply", customer);
    },
    async getCreditLevels() {
      try {
        const res = await creditLevelService.getCreditLevels();
        if (res.data) {
          this.creditLevelList = res.data.creditLevelList;
          this.creditLevelList.unshift({
            id: "",
            name: "----All----",
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    addNewCustomer() {
      this.customerAddDialog = true;
    },
    onCloseNewCustomer(customer) {
      this.customerAddDialog = false;
      if (customer.id) {
        this.apply(customer);
      }
    },
  },
};
</script>

<style></style>
